import React from 'react';
import * as styles from './InfoCard.module.scss';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import RawHTML from '@components/Common/RawHTML/index';

export default function InfoCardV2({
  icon,
  title,
  description,
  dark,
  gradient,
}) {
  let image = '';
  if (icon?.childImageSharp) {
    image = getImage(icon);
  }

  const getCardClass = () => {
    let className =
      'relative  px-7 py-6 flex md:flex-row flex-col gap-x-5 gap-y-4 items-center rounded-[30px] min-h-[178px]';

    if (gradient) {
      className = className.concat(
        ' gradient-card-dark border-gradient border-gradient-radius20 shadow-md blur-[5px]',
      );
    } else if (dark) {
      console.log('bg-v5-green-500', dark);
      className = className.concat(' bg-v5-green-500 ');
    } else {
      className = className.concat(' bg-v5-neutral-200 ');
    }

    if (styles.card) {
      className = className.concat(styles.card);
    }

    return className;
  };

  return (
    <div className={getCardClass()}>
      <div
        className={`${
          gradient &&
          'flex h-[100px] w-[100px] items-center justify-center rounded-xl bg-black bg-opacity-40 backdrop-blur-lg'
        }`}
      >
        <div
          className={`flex ${
            gradient ? 'h-[60px] w-[60px]' : 'w-[80px]'
          } items-center justify-center`}
        >
          {React.isValidElement(icon) ? (
            icon
          ) : (
            <GatsbyImage
              loading="lazy"
              image={image}
              alt={'Highlight'}
              style={{ maxHeight: '100%' }}
              imgStyle={{ objectFit: 'contain' }}
            />
          )}
        </div>
      </div>
      {title && (
        <div
          className={`font-manrope font-semibold ${
            dark ? 'text-v5-green-100' : ''
          }`}
        >
          <RawHTML>{title}</RawHTML>
        </div>
      )}
      {description && (
        <p
          className={`${
            dark ? 'text-v5-neutral-300' : 'text-v5-neutral-400'
          } leading-relaxed`}
        >
          <RawHTML className="flex flex-col gap-2 text-center md:text-left">
            {description}
          </RawHTML>
        </p>
      )}
    </div>
  );
}
